import {PATHS} from '@/const';
import {langUtil} from '@/helper/lang';

export function updateHavePagination(page) {
  const {pathname} = langUtil.parsePathname(page.path);
  return pathname === PATHS.ASSETS_TRANSFER_CONVERT_HISTORY.pathname || pathname === PATHS.ASSETS_DEPOSIT_WITHDRAW_HISTORY.pathname;
}

export const HistoryQueryUtaState = {
  beforeUpgrade: 0,
  afterUpgrade: 1,
};

export const HistoryQueryBusiness = {
  margin: 2,
  utaSpot: 3,
  utaMargin: 4,
};
